import { propOr } from 'ramda'

import capitalize from '@/utils/capitalize'

import useBlogPost from '../stores/use-blog-post'

const postSelector = propOr({}, 'post')

const Main = () => {
  const post = useBlogPost(postSelector)

  return (
    <>
      <div className='mx-auto max-w-7xl'>
        <div className='aspect-w-16 aspect-h-9 mb-8 md:aspect-h-5 md:mb-16'>
          <img
            className='h-full w-full rounded-md object-cover object-center lg:h-full lg:w-full'
            src={post.image.src}
            alt='post banner'
          />
        </div>
      </div>

      <div className='mx-auto max-w-prose text-lg'>
        <h1>
          <span className='mt-2 block text-center text-3xl font-extrabold leading-8 tracking-tight text-gray-900 md:text-4xl'>
            {post.title}
          </span>
          <span className='mt-4 block text-center text-base font-semibold tracking-wide text-theme-blue'>
            By {capitalize(post.author.name)}
          </span>
        </h1>
      </div>
      <div
        className='prose prose-lg prose-indigo mx-auto mt-8 text-gray-500'
        /* eslint-disable-next-line react/no-danger */
        dangerouslySetInnerHTML={{ __html: post.contentHtml }}
      />
    </>
  )
}

export default Main
